/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_No_RolesInputs */

const en_admin_roles_no_roles = /** @type {(inputs: Admin_Roles_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No roles defined yet`)
};

const zh_admin_roles_no_roles = /** @type {(inputs: Admin_Roles_No_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂未定义角色`)
};

/**
* | output |
* | --- |
* | "No roles defined yet" |
*
* @param {Admin_Roles_No_RolesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_roles_no_roles = /** @type {((inputs?: Admin_Roles_No_RolesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_No_RolesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_roles_no_roles(inputs)
	return zh_admin_roles_no_roles(inputs)
});
export { admin_roles_no_roles as "admin.roles.no_roles" }